type LogLevel = 'error' | 'warn' | 'info' | 'debug'

interface LogParams {
  level?: LogLevel
  message: string
  data?: any
}

export const logDataByLevel = async ({
  level = 'error',
  message,
  data,
}: LogParams): Promise<void> => {
  try {
    const payload = {
      level,
      message,
      data: redact(data),
    }
    await fetch('/api/client-log', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload),
      keepalive: true,
    })
  } catch (e) {
    console.warn('client log failed', e)
  }
}

const redact = (loggerObject: any): any => {
  if (loggerObject == null) return loggerObject
  const valueType = typeof loggerObject
  if (valueType !== 'object') return loggerObject

  if (loggerObject instanceof Error) {
    return {
      name: loggerObject.name,
      message: loggerObject.message,
      stack: loggerObject.stack,
    }
  }

  // Safe shallow clone for plain objects / arrays
  const shallowClone = {...loggerObject}
  delete shallowClone.id
  delete shallowClone.charges
  delete shallowClone.customer
  delete shallowClone.customer_id

  if (shallowClone.object === 'payment_method') {
    delete shallowClone.card
    delete shallowClone.billing_details
  } else if (shallowClone.object === 'payment_intent') {
    delete shallowClone.amount_capturable
    delete shallowClone.amount_details
    delete shallowClone.amount_received
    delete shallowClone.application
    delete shallowClone.application_fee_amount
    delete shallowClone.automatic_payment_methods
    delete shallowClone.canceled_at
    delete shallowClone.cancellation_reason
    delete shallowClone.client_secret
    delete shallowClone.excluded_payment_method_types
    delete shallowClone.invoice
    delete shallowClone.last_payment_error
    delete shallowClone.latest_charge
    delete shallowClone.on_behalf_of
    delete shallowClone.payment_method
    delete shallowClone.payment_method_configuration_details
    delete shallowClone.payment_method_options
    delete shallowClone.processing
    delete shallowClone.review
    delete shallowClone.setup_future_usage
    delete shallowClone.shipping
    delete shallowClone.source
    delete shallowClone.transfer_data
    delete shallowClone.transfer_group
  }
  return shallowClone
}
